import { z } from 'zod';

/**
 * Kody błędów zwracane przez API w polu `code`. Interfejs tłumaczy je na komunikaty (NFR-U5).
 * Dopisujemy tu każdy nowy kod – jedno źródło dla api i web.
 */
export const errorCodes = [
  'validation_error',
  'unauthorized',
  'forbidden',
  'not_found',
  'csrf_rejected',
  'invalid_credentials',
  'email_not_verified',
  'too_many_attempts',
  'token_invalid',
  'token_expired',
  'already_active',
  'consent_outdated',
  'consent_required',
  'wrong_password',
  'participant_name_taken',
  'last_admin',
  'edition_slug_taken',
  'edition_slug_locked',
  'edition_status_transition',
  'edition_has_registrations',
  'edition_not_started',
  'edition_date_conflict',
  'edition_not_published',
  'edition_finished',
  'registration_not_open',
  'registration_same_day',
  'participant_age_range',
  'participant_birth_year',
  'participant_guardian',
  'participant_age_conflict',
  'early_access_invalid',
  'room_name_taken',
  'room_has_activities',
  'activity_type_name_taken',
  'activity_type_in_use',
  'activity_type_unknown',
  'activity_symbol_taken',
  'activity_outside_event',
  'activity_conflict',
  'activity_not_cancelled',
  'activity_cancelled',
  'activity_has_history',
  'import_invalid',
  'enrollment_unavailable',
  'enrollment_started',
  'participant_enrolled_started',
  'plan_mail_too_soon',
  'reminder_invalid_time',
  'reminder_locked',
  'campaign_locked',
  'campaign_status',
  'no_recipients',
  'mail_not_resendable',
  'qr_invalid',
  'check_in_closed',
  'participant_checked_in',
  'account_exists',
  'attendance_closed',
  'settings_conflict',
  'internal_error',
] as const;

export type ErrorCode = (typeof errorCodes)[number];

export const apiErrorSchema = z.object({
  code: z.enum(errorCodes),
  message: z.string(),
  details: z.unknown().optional(),
});

export type ApiErrorBody = z.infer<typeof apiErrorSchema>;
